import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgViewList = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 17V7C3 6.45 3.19567 5.97933 3.587 5.588C3.979 5.196 4.45 5 5 5H19C19.55 5 20.021 5.196 20.413 5.588C20.8043 5.97933 21 6.45 21 7V17C21 17.55 20.8043 18.021 20.413 18.413C20.021 18.8043 19.55 19 19 19H5C4.45 19 3.979 18.8043 3.587 18.413C3.19567 18.021 3 17.55 3 17ZM5 9H7V7H5V9ZM9 9H19V7H9V9ZM9 13H19V11H9V13ZM9 17H19V15H9V17ZM5 17H7V15H5V17ZM5 13H7V11H5V13Z",
		fill: "currentColor"
	})
});
export default SvgViewList;
